export const PERMISSION_ACCESS_MANAGER = 'access.manager';
export const PERMISSION_ACCESS_TEACHER = 'access.teacher';
export const PERMISSION_ACCESS_STUDENT = 'access.student';
